import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IRequestAgendarExames } from './types';

// ACTIONS
import { agendarExamesSuccess, agendarExamesFailure } from './actions';

function* agendarExames(request: ReducerAction) {
	const { payload }: { payload: IRequestAgendarExames } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`divisao-equitativa/${CHANNEL}/agendar-exames`,
		payload,
	);

	if (response.status === 200) {
		yield put(agendarExamesSuccess(response));
	} else {
		yield put(agendarExamesFailure(response));
	}
}

export default all([takeLatest(Types.AGENDAR_EXAMES_REQUEST, agendarExames)]);
